import axios from "axios"

export default class Productpost {
    static async getProducts(){
        try{
            const data = {
                type: 'get_products'
            }
            const response = await axios.post('https://td-budkom.com.ua/productpost.php', data, {
                headers : {
                    'Content-Type' : 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            })
            console.log(response)
            return response
        }
        catch(e){
            console.log(e)
        }
    }

    static async getProduct(id){
        try{
            const data = {
                type: 'get_product',
                id: id
            }
            const response = await axios.post('https://td-budkom.com.ua/productpost.php', data, {
                headers : {
                    'Content-Type' : 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            })
            console.log(response)
            return response
        }
        catch(e){
            console.log(e)
        }
    }

    static async getCategories(){
        try{
            const data = {
                type: 'get_categories'
            }
            const response = await axios.post('https://td-budkom.com.ua/productpost.php', data, {
                headers : {
                    'Content-Type' : 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            })
            console.log(response)
            return response
        }
        catch(e){
            console.log(e)
        }
    }
}